import { getCookie, decryptAes } from '../../utils';

const queries = async ({ name }) => {
  const userLoggedState = getCookie();
  const decipher = decryptAes(userLoggedState);

  const params = new URLSearchParams({
    name,
    timestamp: new Date().getTime(),
  });

  const response = await fetch(`${process.env.REACT_APP_HOST_API}/cidade.php?${params}`, {
    method: 'GET',
    signal: AbortSignal.timeout(5000),
    headers: {
      token: decipher.token.value,
      action: 'getByName',
    },
  });

  return await response.json();
}

export default queries;
